export const useFieldFocusManagerStore = defineStore('fieldFocusManager', () => {
  const field = ref<string | undefined>(undefined)

  function onFocusedChange(focusedField: string) {
    return (value: boolean) => {
      if (value) {
        field.value = focusedField
      } else if (field.value === focusedField) {
        field.value = undefined
      }
    }
  }

  return {
    field,
    onFocusedChange,
  }
})
